<template>
  <div>
    <v-list density="compact">
    <v-list-item class="mb-5" :prepend-avatar="require('@/assets/images/avatar.png')">
      <v-list-item-title><b>{{ participant.nombres }}</b></v-list-item-title>
      <v-list-item-subtitle>{{ participant.correo_principal }}</v-list-item-subtitle>
    </v-list-item>
    <v-divider></v-divider>
    <v-list-item title="Inicio" @click="$router.push({name: 'profilehome'})">
      <template v-slot:prepend>
        <v-icon icon="mdi-home"></v-icon>
      </template>
    </v-list-item>
    <v-list-item title="Mis certificados" @click="$router.push({name: 'profilequalified'})">
      <template v-slot:prepend>
        <v-icon icon="mdi-file-certificate-outline"></v-icon>
      </template>
    </v-list-item>
    <v-list-item title="Configuración" @click="$router.push({name: 'profilesetting'})">
      <template v-slot:prepend>
        <v-icon icon="mdi-cog"></v-icon>
      </template>
    </v-list-item>
    <v-list-item title="Cerrar sesión" @click="signout()">
      <template v-slot:prepend>
        <v-icon icon="mdi-exit-to-app"></v-icon>
      </template>
    </v-list-item>
  </v-list>

  <v-dialog v-model="process" max-width="320" persistent >
    <v-list class="py-2" color="primary" elevation="12" rounded="lg" >
      <v-list-item prepend-icon="mdi-clock" title="Espera..." >
        <template v-slot:prepend>
          <div class="pe-4">
            <v-icon color="primary" size="x-large"></v-icon>
          </div>
        </template>
        <template v-slot:append>
          <v-progress-circular color="primary" indeterminate="disable-shrink" size="16" width="2" />
        </template>
      </v-list-item>
    </v-list>
  </v-dialog>
  
  </div>
</template>
<script setup>
  import Params from '@/models/params';
  import axios from 'axios';
  import { useRouter } from 'vue-router';
  import { ref, onMounted, reactive } from 'vue';

  const participant = reactive({
    nombres: null,
    correo_principal: null,
    documento: null
  })

  const router = useRouter();
  const process = ref(false)
  const params = ref(new Params)

  async function signout(){
    process.value = true;
    const frm = new FormData;
    frm.append("action", "signout");
    frm.append("token", localStorage.tokenaccess);
    await axios.post(params.value.controller + 'beneficiario.php', frm).then(res => {
      if(res.data.status){
        router.push({name: "access"})
      }
    })
  }

  onMounted(() => {
    if(localStorage.tokenaccess){
      participant.nombres = localStorage.names
      participant.correo_principal = localStorage.email
      participant.documento = localStorage.document
    }    
  })
</script>